
/* injects from baggage-loader */

'use strict';

import AccountProfileController from './account.profile.controller';
import AccountProfileTemplate from './account.profile.html';

export default class AccountProfileComponent {
		constructor() {
				this.templateUrl = AccountProfileTemplate;
				this.controller = AccountProfileController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					profile: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/profile/account.profile.component.js